<template>
    <div id="app" class="App">
        <template v-if="started">
            <layout-main></layout-main>
            <pixi-background></pixi-background>
            <menu-ribbon></menu-ribbon>
            <rotate-device></rotate-device>
        </template>
        <preloader v-else transitionMode="out-in"></preloader>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import Preloader from './components/base/Preloader'
    import MenuRibbon from './components/MenuRibbon'
    import LayoutMain from './components/layout/LayoutMain'
    import PixiBackground from './components/PixiBackground';
    import RotateDevice from './components/base/RotateDevice'

    export default {
        name: 'App',
        components: {
            Preloader,
            RotateDevice,
            LayoutMain,
            MenuRibbon,
            PixiBackground,
        },
        computed: {
            ...mapState({
                started: state => !state.app.loading,
            }),
        },
    }
</script>

<style src="styles/views/Root.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/Root.vue